<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1">
          Inventarisasi BMD
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Selamat Datang! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Silakan masuk ke akun Anda
          </b-card-text>

          <!-- form -->
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="submitForm"
          >
            <!-- username -->
            <b-form-group
              label="Username"
              label-for="username"
            >
              <b-form-input
                id="username"
                v-model="v$.username.$model"
                :state="validateState(v$.username)"
              />
              <small
                v-for="(error, index) of v$.username.$errors"
                :key="index"
                class="text-danger"
              >{{ error.$message }}</small>
            </b-form-group>

            <!-- forgot password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">Password</label>
                <!-- <b-link :to="{name:'auth-forgot-password-v2'}">
                      <small>Lupa Password</small>
                    </b-link> -->
              </div>
              <b-input-group
                class="input-group-merge"
                :class="v$.password.$errors > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password"
                  v-model="v$.password.$model"
                  :state="validateState(v$.password)"
                  class="form-control-merge"
                  :type="passwordFieldType"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small
                v-for="(error, index) of v$.password.$errors"
                :key="index"
                class="text-danger"
              >{{ error.$message }}</small>
            </b-form-group>

            <!-- tahun -->
            <b-form-group
              label="Tahun"
              label-for="tahun"
            >
              <b-form-select
                id="tahun"
                v-model="tahun"
                :options="dataTahun"
              />
            </b-form-group>

            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="primary"
              block
            >
              <div v-if="isSubmit">
                <b-spinner small />
                <span class="sr-only">Loading...</span>
              </div>
              <div v-else>
                Masuk
              </div>
            </b-button>
          </b-form>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required, helpers, email } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { ref, computed } from '@vue/composition-api'
import moment from 'moment'
import store from '@/store/index'
import helper from '@/libs/helper'
import apiAuth from '@/composables/auth'

export default {
  setup(props, context) {
    const g = context.root

    const year = moment().format('YYYY')

    const username = ref('')
    const password = ref('')
    const tahun = ref(year)

    const isSubmit = ref(false)

    const dataTahun = helper.generateYears(helper.startYear, year)

    const requiredMsg = helper.requiredMessage
    const rules = computed(() => ({
      username: {
        required: helpers.withMessage(`Username ${requiredMsg}`, required),
      },
      password: {
        required: helpers.withMessage(`Password ${requiredMsg}`, required),
      },
    }))

    const fieldForm = { username, password }

    const $externalResults = ref({})
    const v$ = useVuelidate(
      rules,
      fieldForm,
      { $externalResults, $autoDirty: true },
    )

    const { validateState } = helper

    const submitForm = async () => {
      isSubmit.value = true
      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      // jika error validasi
      if (!isFormCorrect) {
        isSubmit.value = false
        return
      }

      // mapping data
      const data = {
        username: username.value,
        password: password.value,
        tahun: tahun.value,
      }

      const result = await apiAuth.login(g, data)
      if (result.isSuccess) {
        g.$router.push({ name: 'autologin', query: { token: 'xxx', username: username.value, tahun: tahun.value } })
      }
      isSubmit.value = false
    }

    return {
      v$,
      ...fieldForm,
      tahun,
      dataTahun,
      validateState,
      submitForm,
      isSubmit,
    }
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      // eslint-disable-next-line global-require
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line global-require, vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
